import { render, staticRenderFns } from "./ProposalCard.vue?vue&type=template&id=c2b440ec&scoped=true"
import script from "./ProposalCard.vue?vue&type=script&lang=js"
export * from "./ProposalCard.vue?vue&type=script&lang=js"
import style0 from "./ProposalCard.vue?vue&type=style&index=0&id=c2b440ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b440ec",
  null
  
)

export default component.exports